import { OffersWarrantyType, PricingDetailsFormValues } from "@dune/types";
import { usePricingDetailsForm } from "../../../../pricing/hooks/usePricingDetailsForm";
import { FormProvider } from "react-hook-form";
import { PricingDetailsForm } from "../../../../pricing/components/PricingDetailsForm";
import { useEffect } from "react";

type PricingDerogationFormProps = {
	warrantyType: OffersWarrantyType;
	pricingDetailsId: number;
	onPricingDetailsChange: (pricingDetails: PricingDetailsFormValues) => void;
};

export const PricingDerogationForm = ({
	warrantyType,
	pricingDetailsId,
	onPricingDetailsChange,
}: PricingDerogationFormProps) => {
	const { form } = usePricingDetailsForm({
		warrantyType,
		pricingDetailsId,
	});

	const { subscribe } = form;

	useEffect(() => {
		const callback = subscribe({
			formState: {
				values: true,
			},
			callback: ({ values }) => {
				onPricingDetailsChange(values);
			},
		});

		return () => callback();
	}, [subscribe, onPricingDetailsChange]);

	return (
		<FormProvider {...form}>
			<PricingDetailsForm warrantyType={warrantyType} />
		</FormProvider>
	);
};
